import { generateUuid } from '@aims/shared/shared/utils';
import { gql, useMutation } from '@apollo/client';
import { Form, Modal, notification } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import EditTransferFormItems from './components/EditTransferFormItems';
import TaskSomethingForm from '../../tasks/ViewTaskModal/TaskSomethingForm';

export const createTransferMutation = gql`
  mutation CreateTransfer($transfer: TransferCreateInput!) {
    createTransfer(transfer: $transfer) {
      transfer {
        _id
      }
    }
  }
`;

const TransferCreateModal = ({ visible, onFinish, onCancel }) => {
  const [saving, setSaving] = useState(false);
  const [createTransfer] = useMutation(createTransferMutation);

  const onSubmit = useCallback(
    async (_values) => {
      setSaving(true);
      try {
        const { ...values } = _values;
        await createTransfer({
          variables: {
            transfer: {
              _id: generateUuid(),
              ...values,
            },
          },
        });
        notification.success({
          message: 'Saved',
          description: 'Transaction created successfully',
        });
        if (onFinish) {
          onFinish();
        }
      } catch (err) {
        console.error(err);
        notification.error({
          message: 'Error',
          description: 'We apologize.  An error occurred',
        });
      }
      setSaving(false);
    },
    [createTransfer, onFinish],
  );

  const [form] = Form.useForm();
  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [form, visible]);

  return (
    <Modal
      header={null}
      open={!!visible}
      closable={!saving}
      destroyOnClose={true}
      maskClosable={true}
      onCancel={onCancel}
      footer={null}
    >
      <TaskSomethingForm
        title="Create Transfer"
        form={form}
        onFinish={onSubmit}
        onCancel={onCancel}
        saving={saving}
      >
        <EditTransferFormItems />
      </TaskSomethingForm>
    </Modal>
  );
};

export default TransferCreateModal;
